import App2 from "./App2";
import { About } from "./about";
import History from "./history";
import Support from "./support";
import { HashRouter, Route, Switch } from "react-router-dom";

export default function App() {
    return (
        <div>
            <HashRouter type="slash">
                <Switch>
                    <Route path="/support" component={Support} />
                    <Route path="/history" component={History} />
                    <Route path="/about" component={About} />
                    <Route path="/" component={App2} />
                </Switch>
            </HashRouter>
        </div>
    );
}

// <Route path="/" exact component={App2} />
// <div>test</div>;
// <Router basename={process.env.PUBLIC_URL}>
// <BrowserRouter basename="/calendar" />;
// <Route path="/esperantoTTS/about/" component={About} />;
